var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20.0001V13.0001H11L7.783 16.2201C8.89296 17.3551 10.4125 17.9965 12 18.0001C14.5394 17.9963 16.8015 16.3943 17.648 14.0001H17.666C17.7805 13.6747 17.8672 13.3402 17.925 13.0001H19.937C19.4331 17 16.0315 20 12 20.0001H11.99C9.86876 20.0064 7.83316 19.1638 6.337 17.6601L4 20.0001ZM6.074 11.0001H4.062C4.56575 7.00169 7.965 4.00222 11.995 4.00004H12C14.1216 3.99325 16.1577 4.83592 17.654 6.34008L20 4.00004V11.0001H13L16.222 7.78008C15.1109 6.64373 13.5893 6.00222 12 6.00008C9.46055 6.00383 7.19848 7.60586 6.352 10.0001H6.334C6.21856 10.3252 6.13189 10.6598 6.075 11.0001H6.074Z",
    fill: "#475A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrow);
export default __webpack_public_path__ + "static/media/borrow.fa09291fae1324195c91df7ffc69c55d.svg";
export { ForwardRef as ReactComponent };